// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DrrpTagbizmgrIconOutlinedSvg from "@fishx/icons-svg/es/asn/DrrpTagbizmgrIconOutlined";
import FishxIcon from '../components/FishxIcon';

var DrrpTagbizmgrIconOutlined = function DrrpTagbizmgrIconOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DrrpTagbizmgrIconOutlinedSvg
  }));
};

DrrpTagbizmgrIconOutlined.displayName = 'DrrpTagbizmgrIconOutlined';
export default React.forwardRef(DrrpTagbizmgrIconOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DrrpTagbizmgrIconOutlined.js
// module id = 2582
// module chunks = 0